"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrefixedTextBundleId = buildPrefixedTextBundleId;
const enums_1 = require("@aurora/shared-types/overrides/enums");
function buildBundleId(locale, namespace, lastModified) {
    return `${locale.replace('-', '_')}-${namespace}-${lastModified !== null && lastModified !== void 0 ? lastModified : 0}`;
}
/**
 * Builds an identifer to be used as an Apollo cache key for Text assets
 * @param locale language identifier
 * @param namespace path to component that bundle is being created for
 * @param lastModified last modified timestamp
 */
function buildPrefixedTextBundleId(locale, namespace, lastModified) {
    return `${enums_1.CachedAssetType.TEXT}:${buildBundleId(locale, namespace, lastModified)}`;
}
//# sourceMappingURL=ApolloTextCacheHelper.js.map